import { UserRoleStatus } from '@redux/user/types';

export const roleStatusLocale = {
  [UserRoleStatus.CONFIRMED]: 'Подтверждено',
  [UserRoleStatus.RETIRED]: 'Отклонено',
  [UserRoleStatus.CREATED_BY_ADMIN]: 'Создано администратором',
  [UserRoleStatus.CREATED_BY_SELF]: 'Создано пользователем',
} as const;
